import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const {
    delayRemove
  } = this.state;
  const hide = this.attr("hide");
  const timeout = this.attr("timeout");
  const type = this.attr("type");
  const cta = this.attr("cta");
  const undoable = this.attr("undoable");
  const hideCancelButton = this.attr("hide-cancel-button");
  return jsx("div", {
    sel: '.mp-toast-stage'
  }, !hide && jsx("div", {
    sel: '.mp-toast-container',
    class: {
      // casting to any, since snabbdom-delayed-module uses a non standard way to hook into snabbdom
      // TODO: modify VNode class definition in Panel to include snabbdom-delayed-module classes
      delayed: {
        'mp-toast-in': true
      },
      remove: {
        'mp-toast-out': true,
        delayRemove
      }
    }
  }, jsx("div", {
    sel: '.mp-toast-widget'
  }, jsx("div", {
    sel: '.icon-container',
    class: {
      [type]: true,
      timeout
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: this.helpers.getIcon()
    }
  }), timeout ? jsx("div", {
    sel: '.icon-container-animated-fadeout',
    class: {
      [type]: true
    },
    style: {
      'animation-duration': timeout + "ms"
    }
  }) : null), jsx("div", {
    sel: '.mp-toast-body'
  }, jsx("div", {
    sel: '.mp-toast-message'
  }, jsx("slot", null)), jsx("div", {
    sel: '.mp-toast-actions'
  }, cta ? jsx("div", {
    sel: '.mp-toast-action.mp-toast-cta',
    on: {
      click: this.helpers.ctaClick
    }
  }, cta) : null, undoable ? jsx("div", {
    sel: '.mp-toast-action.mp-toast-undo',
    on: {
      click: this.helpers.undoClick
    }
  }, "Undo") : null), !hideCancelButton ? jsx("div", {
    sel: '.mp-toast-close',
    on: {
      click: this.helpers.closeClick
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "x"
    }
  })) : null))));
}